import CustomAlert from '../Components/CustomAlert/CustomAlert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axiosInterceptor from './axiosInterceptor';
import { language, messages } from '../language';
import _ from 'lodash';

// const messages = defineMessage({
//     missingMessageTitle: {
//         id: 'New1.missingMessageTitle',
//         defaultMessage: 'You have missing questions'
//     }})

const submitResponse = async (
    data,
    history,
    surveyId,
    clientIp,
    startTimestamp,
    message,
    showMessage,
    isCompleted = true
) => {
    try {
        // await axiosInterceptor().post("survey/" + surveyId, {});
        if(isCompleted){
            await axiosInterceptor().post('survey/' + surveyId, {
                responses: data,
                clientIp: clientIp,
                startTimestamp: startTimestamp,
                endTimestamp: Date.now()
            });
        }else{
            message = language == "fr" ? "réponses manquantes" : "missing answers!"
        }
        if (showMessage) {
            confirmAlert({
                closeOnEscape: false,
                closeOnClickOutside: false,
                customUI: ({ onClose }) => {
                    return (
                        <CustomAlert
                            title={message}
                            onClose={() => {
                                history.push('/survey');
                                onClose();
                            }}
                        ></CustomAlert>
                    );
                }
            });
        }
    } catch (err) {
        console.log(err);
    }
};

export default submitResponse;
